import Urls from "../../constants/urls";
import c1 from "./imgs/C1.jpg";
import c2 from "./imgs/C2.jpg";
import m01 from "./imgs/M01.jpg";
import m02 from "./imgs/M02.jpg";
import m03 from "./imgs/M03.jpg";
import m04 from "./imgs/M04.jpg";
import m05 from "./imgs/M05.jpg";
import m06 from "./imgs/M06.jpg";
import m07 from "./imgs/M07.jpg";
import m08 from "./imgs/M08.jpg";
import m09 from "./imgs/M09.jpg";
import m10 from "./imgs/M10.jpg";
import m11 from "./imgs/M11.jpg";
import m12 from "./imgs/M12.jpg";
import m13 from "./imgs/M13.jpg";
import m14 from "./imgs/M14.jpg";
import m15 from "./imgs/M15.jpg";
import m16 from "./imgs/M16.jpg";
import m17 from "./imgs/M17.jpg";
import m18 from "./imgs/M18.jpg";
import m19 from "./imgs/M19.jpg";
import m20 from "./imgs/M20.jpg";
import m21 from "./imgs/M21.jpg";
import m22 from "./imgs/M22.jpg";
import m23 from "./imgs/M23.jpg";
import md01 from './imgs/MD01.jpg';
import md02 from './imgs/MD02.jpg';
import md03 from './imgs/MD03.jpg';
import md04 from './imgs/MD04.jpg';
import md05 from './imgs/MD05.jpg';
import md06 from './imgs/MD06.jpg';
import md07 from './imgs/MD07.jpg';

export const homeUrl = Urls.northWind.c1.path;

const productIds = {
  "airCrew": "7559976550646",
  "babyPram": "7560038514934",
  "basketball": "7560051458294",
  "basketOfGoodies": "7560049950966",
  "cityOfFun": "7560056471798",
  "covid19Etiquette": "7560055390454",
  "duckDuckTime": "7560062435574",
  "duckDuckTimeToteBag": "7563692376310",
  "familyTime": "7563694637302", // same as team3
  "familyDayOut": "7560057389302",
  "flowerVarse": "7560067743990",
  "flowers": "7563694276854",
  "perspective": "7563528503542",
  "purpleDude": "7563528929526",
  "relationship": "7563691000054",
  "restTimePillow": "7563693850870",
  "sparrowOnTheTank": "7563528044790",
  "springTime": "7560071020790",
  "stuntMan": "7563529388278",
  "theDance": "7563689754870",
  "team3": "7560063975670",
  "greenDude": "7563690213622",
  "playTime": "7569034641654",
  "excitement": "7569085989110",
  "thanksgiving": "7569029660918",
  "flowersToteBag": "7577832915190",
  "orangeDude":"7577840615670",
  "simplyBirds":"7577845432566",
  "springTimeYellow":"7577850708214",
  "joyfulSplash":"7577855295734",
  "theTreasure":"7577857065206",
  "spiralNotebookSparrow":"7563692900598",
}

export const shopifyData = {
  domain: "northwindillustrations.myshopify.com",
  token: "0768184917028dcbc1c6c2e7acde5869",
  productIds: Object.values(productIds),
};

export const calendarId = "nwindgallery"

export const c1Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -45,
    xPosition: 0,
    xRotation: -90,
    yRotation: 180,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: 0,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.md01.path,
    linkRotation: 95,
  },
]

export const c2Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 0,
    xPosition: 100,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 15,
    xPosition: -30,
    xRotation: -90,
    yRotation: 180,
    zRotation: 90,
    radius: 10,
    link: Urls.northWind.md01.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -0.5,
    yPosition: -2,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.restTimePillow,
  },

]

export const md01Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 75,
    xPosition: 0,
    xRotation: -90,
    yRotation: 90,
    zRotation: 90,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: -0.25,
    zPosition: -9.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: -0.25,
    zPosition: -23.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: 5.25,
    yPosition: -1,
    zPosition: -25.5,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: -3,
    yPosition: -1,
    zPosition: 15.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.restTimePillow,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 0,
    zPosition: -20.5,
    yRotation: 280,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 0,
    zPosition: -8,
    yRotation: 280,
    radius: 0.75,
    productId: productIds.springTime,
  },
]

export const md02Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition: -60,
    xRotation: -90,
    yRotation: 180,
    zRotation: 0,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.25,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: 15,
    yPosition: -0.25,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: -9,
    yPosition: -0.25,
    zPosition: -1.5,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
  {
    type:"cart",
    xPosition: -9,
    yPosition: -0.25,
    zPosition: 18,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
  {
    type:"cart",
    xPosition: 19.25,
    yPosition: -1,
    zPosition: 13.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: -0.25,
    yPosition: 0,
    zPosition: 22,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: 11,
    yPosition: 0,
    zPosition: 22,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
]

export const md03Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 110,
    xPosition: -110,
    xRotation: -90,
    yRotation: 180,
    zRotation: -30,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -15,
    yPosition: -0.25,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: 8.25,
    yPosition: -1,
    zPosition: 13.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: -11.5,
    yPosition: 0,
    zPosition: 22,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: 0,
    zPosition: 22,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.25,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: -1,
    zPosition: -1.5,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: -1,
    zPosition: 18,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
]

export const md04Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 150,
    xPosition: 80,
    xRotation: -90,
    yRotation: 180,
    zRotation: 45,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -11.5,
    yPosition: 0,
    zPosition: 15,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: -11.5,
    yPosition: 0,
    zPosition: 2,
    yRotation: -270,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: -6,
    yPosition: -1,
    zPosition: 28,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
  {
    type:"cart",
    xPosition: 15,
    yPosition: -2,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 14,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 2,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },

  {
    type:"cart",
    xPosition: 18.5,
    yPosition: -1,
    zPosition: 28,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
]

export const md05Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 150,
    xPosition: -40,
    xRotation: -90,
    yRotation: 180,
    zRotation: 90,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -20.5,
    yPosition: 0.5,
    zPosition: 13,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: -20.5,
    yPosition: 0.5,
    zPosition: 2,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -2,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: 9,
    yPosition: 0,
    zPosition: 14,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: 9,
    yPosition: 0,
    zPosition: 2,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
  {
    type:"cart",
    xPosition: -19,
    yPosition: -1,
    zPosition: 28,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
  {
    type:"cart",
    xPosition: -9,
    yPosition: -1,
    zPosition: 35,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.restTimePillow,
  },

  {
    type:"cart",
    xPosition: 5,
    yPosition: -1,
    zPosition: 28,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
  
]

export const md06Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 50,
    xPosition: 120,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
  {
    type:"cart",
    xPosition: 13,
    yPosition: -0.5,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: -12,
    yPosition: -2,
    zPosition: 1,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: 12,
    yPosition: 0,
    zPosition: 22,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: 0,
    zPosition: 22,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: 20.5,
    yPosition: -1,
    zPosition: 16,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
  {
    type:"cart",
    xPosition: 20.5,
    yPosition: -1,
    zPosition: -3.5,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
  {
    type:"cart",
    xPosition: 25.5,
    yPosition: -0.5,
    zPosition: 7,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.restTimePillow,
  },
]

export const md07Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 50,
    xPosition: 40,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -13,
    yPosition: -0.5,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.sparrowOnTheTank,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.springTime,
  },
  {
    type:"cart",
    xPosition: -22,
    yPosition: -1.5,
    zPosition: 1,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.flowerVarse,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: 0,
    zPosition: 22,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: -12,
    yPosition: 0,
    zPosition: 22,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.springTimeYellow,
  },
  {
    type:"cart",
    xPosition: 10.5,
    yPosition: -1,
    zPosition: -3.5,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.flowersToteBag,
  },
  {
    type:"cart",
    xPosition: 17.5,
    yPosition: -0.5,
    zPosition: 7.5,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.restTimePillow,
  },
  {
    type:"cart",
    xPosition: 10.5,
    yPosition: -1,
    zPosition: 18.5,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.spiralNotebookSparrow,
  },
]


export const smallRoomHotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: 90,
    xRotation: -90,
    yRotation: 50,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: -140,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -19.5,
    yPosition: -0.5,
    zPosition: -5.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type:"cart",
    xPosition: -19.5,
    yPosition: -0.5,
    zPosition: 8.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type:"cart",
    xPosition: -10.5,
    yPosition: 0,
    zPosition: -14,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: -4.5,
    yPosition: 0,
    zPosition: -14,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 1,
    yPosition: 0,
    zPosition: -14,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 7,
    yPosition: 0,
    zPosition: -14,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 14,
    yPosition: 0,
    zPosition: -9,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type:"cart",
    xPosition: 14,
    yPosition: 0,
    zPosition: -2,
    yRotation: -50,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type:"cart",
    xPosition: 14,
    yPosition: 0,
    zPosition: 11.5,
    yRotation: -80,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type:"cart",
    xPosition: 14,
    yPosition: -0.3,
    zPosition: 22.5,
    yRotation: -80,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
]

export const m1Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: 20,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 55,
  },
  
  {
    type:"cart",
    xPosition: 0,
    yPosition: -2,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -13,
    yPosition: -2,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 13,
    yPosition: -2,
    zPosition: -8,
    yRotation: 2,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 24,
    yPosition: -2,
    zPosition: -8,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: 43,
    yPosition: -2,
    zPosition: -8,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -2,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -42,
    yPosition: -2,
    zPosition: -8.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -1,
    zPosition: 0.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -1,
    zPosition: 9.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -1,
    zPosition: 18.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -1,
    zPosition: 27.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -42,
    yPosition: -1,
    zPosition: 34,
    yRotation: 100,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -1,
    zPosition: 34,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -1,
    zPosition: 34,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -33,
    yPosition: -1,
    zPosition: 34,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: 12,
    yPosition: 0,
    zPosition: 24,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: -55,
    xPosition: 200,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: 375,
    xPosition: 200,
    xRotation: -70,
    yRotation: 150,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  
]

export const m23Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: 90,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: -55,
    xPosition: 200,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 185,
    xPosition: 200,
    xRotation: -70,
    yRotation: 150,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 85,
    xPosition: -100,
    xRotation: -70,
    yRotation: 70,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m22.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: 90,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: -55,
    xPosition: 200,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 185,
    xPosition: 200,
    xRotation: -70,
    yRotation: 150,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 85,
    xPosition: -100,
    xRotation: -70,
    yRotation: 70,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m22.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -1,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 12,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 25,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 2,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -13,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 30,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -0.25,
    zPosition: 0.25,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -0.25,
    zPosition: 6.5,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -0.25,
    zPosition: 13.25,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -0.25,
    zPosition: 19.5,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -29,
    yPosition: -0.25,
    zPosition: 13.25,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -27.5,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -19,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -11,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -2.75,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
]


export const m3Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: 160,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: -55,
    xPosition: 350,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 185,
    xPosition: 340,
    xRotation: -90,
    yRotation: 150,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 85,
    xPosition: -20,
    xRotation: -70,
    yRotation: 70,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m22.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 40,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: -15,
    radius: 0.75,
    productId: productIds.basketball,
  }, {
    type: "cart",
    xPosition: 60,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: -25,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -27,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 30,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -1,
    zPosition: 0.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -1,
    zPosition: 30.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -1,
    zPosition: 10.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -1,
    zPosition: 20.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -8.5,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -0.5,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: 7.5,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
]

export const m12Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 70,
    xPosition: 50,
    xRotation: -90,
    yRotation: 0,
    zRotation: 330,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "cart",
    xPosition: -44,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: -30,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: -5.0,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -0.5,
    zPosition: 6,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -0.5,
    zPosition: 12,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -0.5,
    zPosition: 18,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type: "cart",
    xPosition: 4.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 14.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 32.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
]

export const m13Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 0,
    xPosition: 100,
    xRotation: -90,
    yRotation: 0,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 210,
    xPosition: 30,
    xRotation: -100,
    yRotation: 45,
    zRotation: 330,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -28,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 15,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 27,
    yPosition: -0.5,
    zPosition: -7.0,
    yRotation: 270,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 7,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 13.5,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 19.5,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type: "cart",
    xPosition: -10.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: 3,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m14Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 0,
    xPosition: 180,
    xRotation: -90,
    yRotation: 0,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 210,
    xPosition: 100,
    xRotation: -100,
    yRotation: 45,
    zRotation: 340,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 14,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 28,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 28,
    yPosition: -0.5,
    zPosition: -4.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 0.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 8,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 15,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 22,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type: "cart",
    xPosition: -2.5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const perspectiveHotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 0,
    xPosition: 220,
    xRotation: -90,
    yRotation: 0,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 210,
    xPosition: 150,
    xRotation: -100,
    yRotation: 45,
    zRotation: 340,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 15,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 28.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 42,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 42,
    yPosition: -0.5,
    zPosition: -5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 1,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 17,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 32,
    yRotation: 110,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 47,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type: "cart",
    xPosition: 5,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.5,
    zPosition: 27,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },

]

export const m15Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 240,
    xPosition: 0,
    xRotation: -92,
    yRotation: 0,
    zRotation: 200,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: -200,
    xRotation: -90,
    yRotation: 45,
    zRotation: 220,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -41.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: -28.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: -15.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: -1,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 10,
    yPosition: 0,
    zPosition: 0,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: 0,
    zPosition: 11,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: 0,
    zPosition: 22,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: 0,
    zPosition: 34,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 3.5,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -0.5,
    zPosition: 4.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -24,
    yPosition: -0.5,
    zPosition: 16,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m16Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 220,
    xPosition: 100,
    xRotation: -92,
    yRotation: 0,
    zRotation: 220,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 190,
    xPosition: -140,
    xRotation: -90,
    yRotation: 45,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -26.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: -13.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 13.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 0,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 12,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 24,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 36.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 17,
    yPosition: -0.5,
    zPosition: 45.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -1,
    zPosition: 5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -1,
    zPosition: 18,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -1,
    zPosition: 28,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
]

export const m17Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 170,
    xPosition: 150,
    xRotation: -92,
    yRotation: 0,
    zRotation: 240,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 190,
    xPosition: -80,
    xRotation: -90,
    yRotation: 45,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -13.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 13.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 27.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 0,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 8,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 16.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 24.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.duckDuckTimeToteBag,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -1,
    zPosition: 6.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -1,
    zPosition: 23,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -1,
    zPosition: 35.5,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -1,
    zPosition: 47,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.basketball,
  },
]

export const m18Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: 200,
    xRotation: -92,
    yRotation: 0,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 150,
    xPosition: -30,
    xRotation: -90,
    yRotation: 45,
    zRotation: 270,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: 8,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 15.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: -13.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: -4,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 2.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 9,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type: "cart",
    xPosition: 23,
    yPosition: 0,
    zPosition: 15,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -2,
    zPosition: 0.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -2,
    zPosition: 33.0,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -2,
    zPosition: 55.0,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -2,
    zPosition: 77.0,
    yRotation: 130,
    radius: 0.75,
    productId: productIds.basketball,
  },
]

export const m19Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 220,
    xPosition: -5,
    xRotation: -90,
    yRotation: 360,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -10,
    xPosition: -100,
    xRotation: -90,
    yRotation: 45,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: 25,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: -20,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -18,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -35,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -70,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: -0.25,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 5.25,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 11,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 16.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 15,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -120,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type:"cart",
    xPosition: 9,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -120,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type:"cart",
    xPosition: 2.5,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -130,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
]

export const familyDayOutHotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 200,
    xPosition: -150,
    xRotation: -92,
    yRotation: 360,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -20,
    xPosition: -150,
    xRotation: -90,
    yRotation: 45,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 180,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -43,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -60,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 30,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -75,
    yPosition: -2,
    zPosition: -13.0,
    yRotation: 30,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: -0.25,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.playTime,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 11,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.flowers,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 23.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.excitement,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0,
    zPosition: 37.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.theDance,
  },
  {
    type:"cart",
    xPosition: 3.5,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.perspective,
  },
  {
    type:"cart",
    xPosition: -2,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.thanksgiving,
  },
  {
    type:"cart",
    xPosition: -8.5,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.orangeDude,
  },
  {
    type:"cart",
    xPosition: -15,
    yPosition: 0,
    zPosition: 22.5,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
]

export const m20Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 130,
    xPosition: -60,
    xRotation: -70,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 55,
  },
  {
    type: "arrow",
    yPosition: -75,
    zPosition: 85,
    xPosition: -240,
    xRotation: -70,
    yRotation: 50,
    zRotation: 170,
    radius: 10,
    link: Urls.northWind.m22.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: -55,
    xPosition: 100,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -95,
    zPosition: 375,
    xPosition: 80,
    xRotation: -70,
    yRotation: 150,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type:"cart",
    xPosition: -11,
    yPosition: -1,
    zPosition: -8,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -21,
    yPosition: -1,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: -8,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: 26,
    yPosition: -1,
    zPosition: -8,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -1,
    zPosition: -8,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -47,
    yPosition: -1,
    zPosition: -8.0,
    yRotation: 20,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -0.5,
    zPosition: -1.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -0.5,
    zPosition: 6.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -0.5,
    zPosition: 13.75,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -52,
    yPosition: -0.5,
    zPosition: 21.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -39,
    yPosition: -0.5,
    zPosition: 24,
    yRotation: 170,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -32,
    yPosition: -0.5,
    zPosition: 24,
    yRotation: 175,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -25.5,
    yPosition: -0.5,
    zPosition: 24,
    yRotation: 175,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: 4,
    yPosition: 0,
    zPosition: 24,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.duckDuckTime,
  },
]


export const mainRoomHotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -5,
    xPosition: 70,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.c1.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: -80,
    xRotation: -90,
    yRotation: 120,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m22.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -90,
    xPosition: 40,
    xRotation: -90,
    yRotation: 230,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: -90,
    xPosition: -120,
    xRotation: -90,
    yRotation: 230,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m02.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: -15.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: -7.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: 1.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: 9,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: 17.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -16,
    yPosition: -0.5,
    zPosition: 28.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -13,
    yPosition: -0.3,
    zPosition: 43,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -5.50,
    yPosition: -0.3,
    zPosition: 43,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 1.50,
    yPosition: -0.3,
    zPosition: 43,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  // {
  //   type: "cart",
  //   xPosition: 9,
  //   yPosition: -0.3,
  //   zPosition: 43,
  //   yRotation: 180,
  //   radius: 0.75,
  //   productId: productIds.familyDayOut,
  // },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.3,
    zPosition: 42,
    yRotation: 150,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
];

export const m10Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: 10,
    xRotation: -100,
    yRotation: 40,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -8.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: 9.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: -0.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 10,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 20.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 30.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 12,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -9,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -17.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -26,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -34.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m11Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 90,
    xPosition: 50,
    xRotation: -100,
    yRotation: 40,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: 9,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: 27,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 8,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 15,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 32,
    yPosition: -0.5,
    zPosition: 23,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 18,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 6.25,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -2.25,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -10.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -19.25,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -28,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m08Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition: 70,
    xRotation: -90,
    yRotation: 120,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: 22.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: 32.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: 11.0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -0.5,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 30,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 2.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 13.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 21.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 29.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 38.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -0.5,
    zPosition: 46.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m04Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 70,
    xPosition: 100,
    xRotation: -90,
    yRotation: 180,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -3,
    yPosition: -0.25,
    zPosition: 27,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: 19,
    yPosition: -0.25,
    zPosition: 27,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: 11.75,
    yPosition: -0.25,
    zPosition: 27,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: 4.5,
    yPosition: -0.25,
    zPosition: 27,
    yRotation: -180,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 34,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 24,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 12,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: -15,
    yPosition: -0.5,
    zPosition: 1,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -1,
    yPosition: -2,
    zPosition: -15,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 33,
    yPosition: -2,
    zPosition: -15,
    yRotation: -20,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 55,
    yPosition: -2,
    zPosition: -15,
    yRotation: -20,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 75,
    yPosition: -2,
    zPosition: -15,
    yRotation: -20,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 100,
    yPosition: -2,
    zPosition: -15,
    yRotation: -20,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
]

export const m05Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 150,
    xPosition: -50,
    xRotation: -90,
    yRotation: 70,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -0.5,
    zPosition: -0.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -0.5,
    zPosition: 13,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -0.5,
    zPosition: 20,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -25,
    yPosition: -0.5,
    zPosition: 6.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -30,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: 10,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: 4,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: 25,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: 40,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: 55.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -1,
    zPosition: 70.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
]

export const m06Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 150,
    xPosition: 50,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 7,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 14,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 21,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 4,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 18.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 29.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 40.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 50.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 15.5,
    yPosition: -1,
    zPosition: 61.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m07Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition: 70,
    xRotation: -90,
    yRotation: 90,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 10,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 21.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 32.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: -10,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 2.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 17.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 28.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 38.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 48.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 60.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m09Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition:20,
    xRotation: -90,
    yRotation: 40,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -9,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -18,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -0.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: 8.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: 0,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: 10,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: 20.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 20,
    yPosition: -0.5,
    zPosition: 30,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 4.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -8,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -17,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -25.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -35.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -42.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const purpleDudeHotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition: -50,
    xRotation: -90,
    yRotation: 30,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -17.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -25.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: 0,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: 5,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -8.5,
    yPosition: -0.5,
    zPosition: -8.0,
    yRotation: -2,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: -0.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: 10,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: 20,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 10,
    yPosition: -0.5,
    zPosition: 30,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: -2,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: -14,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: -23,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: -31,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: -40.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: -48.5,
    yPosition: -0.5,
    zPosition: 25,
    yRotation: 180,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
]

export const m22Hotspots = [
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 40,
    xPosition: 70,
    xRotation: -90,
    yRotation: 70,
    zRotation: 180,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: -17.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.purpleDude,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: -7.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.relationship,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 2,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.joyfulSplash,
  },
  {
    type: "cart",
    xPosition: -20,
    yPosition: -0.5,
    zPosition: 12,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.theTreasure,
  },
  {
    type: "cart",
    xPosition: -9,
    yPosition: -0.5,
    zPosition: -20,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.simplyBirds,
  },
  {
    type: "cart",
    xPosition: -2,
    yPosition: -0.5,
    zPosition: -20,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.greenDude,
  },
  {
    type: "cart",
    xPosition: 5,
    yPosition: -0.5,
    zPosition: -20,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.team3,
  },
  {
    type: "cart",
    xPosition: 12.5,
    yPosition: -0.5,
    zPosition: -20,
    yRotation: -10,
    radius: 0.75,
    productId: productIds.stuntMan,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: -13.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.airCrew,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 3,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.babyPram,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 15,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketOfGoodies,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 26,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.basketball,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 38.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.covid19Etiquette,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 50.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.cityOfFun,
  },
  {
    type: "cart",
    xPosition: 23.5,
    yPosition: -1,
    zPosition: 65.5,
    yRotation: -110,
    radius: 0.75,
    productId: productIds.familyDayOut,
  },
]

export const flowersToteHotspots = [
   {
    type: "arrow",
    yPosition: -45,
    zPosition: -90,
    xPosition: 0,
    xRotation: -90,
    yRotation: 180,
    zRotation: 0,
    radius: 10,
    link: Urls.northWind.md01.path,
    linkRotation: 95,
  },
  {
    type: "arrow",
    yPosition: -45,
    zPosition: 80,
    xPosition: 0,
    xRotation: -90,
    yRotation: 180,
    zRotation: 90,
    radius: 10,
    link: Urls.northWind.m21.path,
    linkRotation: 95,
  },
]

export const rooms = [
  {
    id:'m21',
    name: 'Gallery Entrance',
    img: m21,
    route: Urls.northWind.m21,
    yRotation: 360,
    isShowroom: true
  },{
    id:'m03',
    name: 'Baby Pram',
    img: m03,
    route: Urls.northWind.m03,
    yRotation: 360,
  },{
    id:'m23',
    name: 'Basket of Goodies',
    img: m23,
    route: Urls.northWind.m23,
    yRotation: 360,
  },
  {
    id:'m01',
    name: 'Basket Ball',
    img: m01,
    route: Urls.northWind.m01,
    yRotation: 360,
  },
    {
    id:'m20',
    name: 'Covid 19 Etiquette',
    img: m20,
    route: Urls.northWind.m20,
    yRotation: 360,
  },
  {
    id:'m22',
    name: 'Main Gallery Room',
    img: m22,
    route: Urls.northWind.m22,
    yRotation: 360,
    isShowroom: true
  }, 
  {
    id:'m11',
    name: 'The Treasure',
    img: m11,
    route: Urls.northWind.m11,
    yRotation: 360,
  },
  {
    id:'m10',
    name: 'The Splash',
    img: m10,
    route: Urls.northWind.m10,
    yRotation: 270,
  },
  {
    id:'m09',
    name: 'Relationship',
    img: m09,
    route: Urls.northWind.m09,
    yRotation: 360,
  },
  {
    id:'purple-dude',
    name: 'Purple Dude',
    img: m08,
    route: Urls.northWind.purpleDude,
    yRotation: 360,
  },
  {
    id:'m08',
    name: 'Simply Birds',
    img: m08,
    route: Urls.northWind.m08,
    yRotation: 360,
  }, {
    id:'m07',
    name: 'Green Dude',
    img: m07,
    route: Urls.northWind.m07,
    yRotation: 360,
  },
  {
    id:'m06',
    name: 'Team 3',
    img: m06,
    route: Urls.northWind.m06,
    yRotation: 360,
  },
  {
    id:'m05',
    name: 'Stunt Man',
    img: m05,
    route: Urls.northWind.m05,
    yRotation: 360,
  }, 
  {
    id:'m04',
    name: 'Air Crew',
    img: m04,
    route: Urls.northWind.m04,
    yRotation: 360,
  }, 
  {
    id:'m02',
    name: 'Small Gallery Room',
    img: m02,
    route: Urls.northWind.m02,
    yRotation: 360,
    isShowroom: true
  },
  {
    id:'m19',
    name: 'City of Fun',
    img: m19,
    route: Urls.northWind.m19,
    yRotation: 360,
  },
  {
    id:'family-time',
    name: 'Family Day Out',
    img: m18,
    route: Urls.northWind.familyTime,
    yRotation: 360,
  },
  {
    id:'m18',
    name: 'Play Time',
    img: m18,
    route: Urls.northWind.m18,
    yRotation: 360,
  },
  {
    id:'m17',
    name: 'Flowers',
    img: m17,
    route: Urls.northWind.m17,
    yRotation: 360,
  },
  {
    id:'m16',
    name: 'Excitement',
    img: m16,
    route: Urls.northWind.m16,
    yRotation: 360,
  },
  {
    id:'m15',
    name: 'Dance Time',
    img: m15,
    route: Urls.northWind.m15,
    yRotation: 360,
  },
  {
    id:'perspective',
    name: 'Perspective',
    img: m15,
    route: Urls.northWind.perspective,
    yRotation: 360,
  },
  {
    id:'m14',
    name: 'Thanksgiving',
    img: m14,
    route: Urls.northWind.m14,
    yRotation: 360,
  },  
   {
    id:'m13',
    name: 'Orange Dude',
    img: m13,
    route: Urls.northWind.m13,
    yRotation: 360,
  },
  {
    id:'m12',
    name: 'Duck Duck Time',
    img: m12,
    route: Urls.northWind.m12,
    yRotation: 360,
  },
  {
    id:'c1',
    name: 'Corridor',
    img: c1,
    route: Urls.northWind.c1,
    yRotation: 360,
    isShowroom: true
  },
  {
    id:'flowers-tote',
    name: "Flower Varse Tote Bag",
    img: c1,
    route: Urls.northWind.flowersTote,
    yRotation: 360,
  },
  {
    id:'c2',
    name: "Rest Time Pillow",
    img: c2,
    route: Urls.northWind.c2,
    yRotation: 360,
  },
  {
    id: 'md01',
    name: 'Side Gallery',
    img: md01,
    route: Urls.northWind.md01,
    yRotation: 360,
    isShowroom: true
  },
  {
    id: 'md02',
    name: 'City of Fun',
    img: md02,
    route: Urls.northWind.md02,
    yRotation: 360,
  },
  {
    id: 'md03',
    name: 'Spring Time(Yellow)',
    img: md03,
    route: Urls.northWind.md03,
    yRotation: 360,
  },
  {
    id: 'md04',
    name: 'md04',
    img: md04,
    route: Urls.northWind.md04,
    yRotation: 360,
  },
  {
    id: 'md05',
    name: 'Flower Varse',
    img: md05,
    route: Urls.northWind.md05,
    yRotation: 360,
  },
  {
    id: 'md06',
    name: 'Sparrow on The Tank',
    img: md06,
    route: Urls.northWind.md06,
    yRotation: 360,
  },
  {
    id: 'md07',
    name: 'Spring Time',
    img: md07,
    route: Urls.northWind.md07,
    yRotation: 360,
  },
]